// extracted by mini-css-extract-plugin
export default {"paymentForm":"form_paymentForm__pZUUe","paymentElement":"form_paymentElement__M8GAw","input":"form_input__-kuR9"};